/**
 * تحديث 80: شريط النطاق العام (نوع أمر العمل متعدد / عقود متعددة / أقسام / من–إلى).
 * مخزن خارج React (كالعقد النشط) ليقرأه مُعترِض axios؛ يُرسل في الترويسة X-ASF-Scope
 * ويضيّق الخادم به القوائم والتقارير فقط (لا الصلاحيات).
 */
export const SCOPE_HEADER = "X-ASF-Scope";
const KEY = "asf.scopeSelection";
const EMPTY = { t: [], c: [], d: [], f: "", e: "" };

let current = read();

function clean(v) {
  const arr = (x) => (Array.isArray(x) ? x : []);
  return {
    t: arr(v?.t).filter((x) => typeof x === "string"),
    c: arr(v?.c).map(Number).filter((n) => Number.isInteger(n) && n > 0),
    d: arr(v?.d).map(Number).filter((n) => Number.isInteger(n) && n > 0),
    f: typeof v?.f === "string" ? v.f : "",
    e: typeof v?.e === "string" ? v.e : "",
  };
}

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? clean(JSON.parse(raw)) : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
}

export function getScope() {
  return current;
}

export function isScopeActive(s = current) {
  return s.t.length > 0 || s.c.length > 0 || s.d.length > 0 || !!s.f || !!s.e;
}

export function setScope(next) {
  current = clean(next);
  try {
    if (isScopeActive()) localStorage.setItem(KEY, JSON.stringify(current));
    else localStorage.removeItem(KEY);
  } catch {
    /* التخزين تحسين لا شرط */
  }
}

export function scopeHeaderValue() {
  return isScopeActive() ? encodeURIComponent(JSON.stringify(current)) : null;
}

/** تحديث 95: قيمة الترويسة لنطاق معيّن (مثلاً النطاق بلا الأنواع حين تنقلها الصفحة إلى جسم الطلب) — "" = بلا نطاق. */
export function scopeHeaderOf(s) {
  const v = clean(s);
  return isScopeActive(v) ? encodeURIComponent(JSON.stringify(v)) : "";
}
